import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="bg-foreground text-background">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-4 gap-8 py-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Heart" size={24} color="white" />
              </div>
              <span className="text-xl font-bold">AI Dating</span>
            </div>
            <p className="text-background/70 text-sm">
              Первый в мире полностью автоматизированный сервис знакомств на основе AI
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Компания</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/payment-page" className="hover:text-background transition-colors">Оплата</Link></li>
              <li><a href="#webinars" className="hover:text-background transition-colors">Вебинары</a></li>
              <li><Link to="/contract-offer-page" className="hover:text-background transition-colors">Договор-оферта</Link></li>
              <li><Link to="/careers-page" className="hover:text-background transition-colors">Карьера</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Поддержка</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li><a href="#faq" className="hover:text-background transition-colors">FAQ</a></li>
              <li><Link to="/founder-s-mini-book-page" className="hover:text-background transition-colors">Мини-книга основателя</Link></li>
              <li><Link to="/mission-code-11-resonance-society-page" className="hover:text-background transition-colors">Миссия</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Контакты</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li>
                <a
                  href="https://wa.me/66823204796?text=Здравствуйте!%20Я%20хочу%20узнать%20больше%20о%20вашем%20сервисе%20AI%20Dating."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-background transition-colors inline-flex items-center gap-2"
                >
                  <Icon name="MessageCircle" size={16} color="currentColor" />
                  <span>WhatsApp</span>
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/Aidating_love7_bot?start=014_res"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-background transition-colors inline-flex items-center gap-2"
                >
                  <Icon name="Send" size={16} color="currentColor" />
                  <span>Telegram</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 pb-6 border-t border-background/10 text-center text-sm text-background/70">
          <p>&copy; {currentYear} AI Dating Service. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;